import React from "react"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "src/components/ui/sheet"
import { TagForm } from "./TagForm"
import { useCreateTag, useUpdateTag } from "../hooks/useTags"
import { useToast } from "src/components/ui/toast"

export function TagDrawer({ open, onClose, tag, onSuccess }) {
  const isEdit = !!tag
  const { toast } = useToast()
  const createHook = useCreateTag()
  const updateHook = useUpdateTag()
  const isPending = createHook.isPending || updateHook.isPending

  async function handleSubmit(payload) {
    try {
      if (isEdit) {
        await updateHook.mutate(tag.id, payload)
        toast({ title: "Tag updated", description: payload.name })
      } else {
        await createHook.mutate(payload)
        toast({ title: "Tag created", description: payload.name })
      }
      onSuccess?.()
      onClose()
    } catch (errors) {
      const msg = Array.isArray(errors) ? errors[0] : (errors?.message || "Something went wrong")
      toast({ variant: "destructive", title: "Error", description: msg })
    }
  }

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="flex flex-col p-0 sm:max-w-[440px]">
        <SheetHeader>
          <SheetTitle>{isEdit ? "Edit tag" : "New tag"}</SheetTitle>
          <SheetDescription>
            {isEdit ? "Update this tag's name, color or description." : "Tags help you categorize and filter records."}
          </SheetDescription>
        </SheetHeader>
        <TagForm tag={tag} onSubmit={handleSubmit} onCancel={onClose} isPending={isPending} />
      </SheetContent>
    </Sheet>
  )
}
